import React from "react";
import styled from "styled-components";
import Button from "../Buttons/Button";

const Container = styled.span`
  & button.status {
    min-width: auto;
    height: auto;
    padding: 1rem 2rem;
    border-radius: 999px;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    background-color: transparent;
    box-shadow: none;
    line-height: 1.4;
    transition: background-color .2s ease, color .2s ease, transform .2s ease;
  }
  & button.status:hover { transform: translateY(-1px); }

  /* status palette — outlined pill chips */
  .Invited, .Hidden, .Invisible, .Ingewisseld, .Nieuw, .Teversturen {
    border: 1px solid rgba(58, 58, 58, 0.4);
    color: var(--color-status-new);
    background-color: rgba(58, 58, 58, 0.06);
    cursor: default;
  }
  .Created, .Finished, .Visible, .Actief, .Gelanceerd, .Betaald, .Toegevoegd, .true {
    border: 1px solid rgba(27, 183, 117, 0.45);
    color: var(--color-status-good);
    background-color: rgba(27, 183, 117, 0.10);
    cursor: default;
  }
  .Deleted, .Inactief, .Finaalvervallen, .Afgewezen, .Verwijderd {
    border: 1px solid rgba(214, 40, 9, 0.45);
    color: var(--color-status-bad);
    background-color: rgba(214, 40, 9, 0.08);
    cursor: default;
  }
  .Vervallen, .Bevestigd, .Inbehandeling, .false {
    border: 1px solid rgba(217, 138, 2, 0.45);
    color: var(--color-status-warning);
    background-color: rgba(217, 138, 2, 0.10);
    cursor: default;
  }
  .Verzonden, .Odoo {
    border: 1px solid rgba(41, 134, 204, 0.45);
    color: var(--color-status-info);
    background-color: rgba(41, 134, 204, 0.08);
    cursor: default;
  }

  .notAllowed { cursor: not-allowed; }
`;

export default function Status({ className, label, onClick, notAllowed }) {
  const advancedOnClick = () => {
    if (notAllowed) return false;
    onClick && onClick();
  };

  return (
    <Container>
      <Button
        type={`status ` + (className?.replace(/\s/g, "") ?? label) + (notAllowed ? " notAllowed" : "")}
        label={label}
        onClick={advancedOnClick}
      />
    </Container>
  );
}

Status.defaultProps = {
  label: "",
};
